import { useRegisterSW } from 'virtual:pwa-register/react';
import { useCallback, useEffect } from 'react';

/**
 * Hook for handling PWA service worker updates.
 * Uses 'prompt' strategy - user must explicitly approve updates.
 * 
 * This prevents unexpected app reloads during active work.
 */
export function usePwaUpdate() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      // Check for updates every hour
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
      }
      console.log('[PWA] Service Worker registered');
    },
    onRegisterError(error) {
      console.error('[PWA] Service Worker registration failed:', error);
    },
  });

  // Log when offline ready
  useEffect(() => {
    if (offlineReady) {
      console.log('[PWA] App ready to work offline');
    }
  }, [offlineReady]);

  const handleUpdate = useCallback(() => {
    updateServiceWorker(true);
  }, [updateServiceWorker]);

  const dismissUpdate = useCallback(() => {
    setNeedRefresh(false);
  }, [setNeedRefresh]);

  return {
    needRefresh,
    offlineReady,
    handleUpdate,
    dismissUpdate,
  };
}
